//#region src/core/logger.ts
var e = !1, t = {
	setVerbose(t) {
		e = t;
	},
	debug(...t) {
		e && console.debug("[DataLayer]", ...t);
	},
	info(...t) {
		e && console.info("[DataLayer]", ...t);
	},
	warn(...e) {
		console.warn("[DataLayer]", ...e);
	},
	error(...e) {
		console.error("[DataLayer]", ...e);
	}
};
//#endregion
export { t as logger };
